<template>
  <main class="is-fullheight">
    <div>
      <spinner size="large" line-fg-color="#44c7f0"
               :line-size="5" class="spinner" message="Loading..." />
    </div>
  </main>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import Wallet from '@/api/wallet'
import {mapActions, mapMutations} from 'vuex'
import { userSession, getUserData, getUser } from '@/helpers/stack-auth'

export default {
  components: { Spinner },
  methods: {
    ...mapMutations('signupForm', [
      'setError'
    ]),
    ...mapActions('wallet', ['connectStack', 'disconnectStack']),
    async stackConnect (userData, user) {
      this.connectStack({
        userData, user
      })
    }
  },
  async mounted () {
    const token = this.$route.query.token
    const accountId = this.$route.query.account_id
    try {
      if (token && accountId) {
        const link = await Wallet.confirmWalletByEmail({ token, accountId })
        if (link.confirmed) {
          const userData = getUserData()
          const user = getUser()
          await this.stackConnect(userData, user)
          this.$store.dispatch('users/getUser')
          this.$router.push('/wallet')
        } else {
          userSession.signUserOut()
          this.disconnectStack()
          this.$router.push('/')
        }
      } else {
        this.$router.push('/wallet')
      }
    } catch (error) {
      this.$router.push('/wallet')
    }
  }
}
</script>

<style lang="scss" scoped>
.is-fullheight {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/magic-wallet.vue